var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UA_FLAG, APPSDK_JS, FUSE_VERSION_STRING } from '../const/app';
import { loadScript, getCookie } from '../utils/tools';
import { getUrlParam, setUrlParam } from '../utils/urlMethod';
// import { is58App } from '../utils/appTools'
var userAgent;
/** 获取h5运行环境 */
export var getAppType = function (_userAgent) {
    if (typeof _userAgent != 'undefined') {
        userAgent = _userAgent.toLowerCase();
    }
    else if (typeof userAgent == 'undefined' && typeof window != "undefined") {
        userAgent = navigator.userAgent.toLowerCase();
    }
    var type = '';
    for (var key in UA_FLAG) {
        if (userAgent && userAgent.indexOf(key) != -1) {
            type = UA_FLAG[key];
            break;
        }
    }
    if (!type) {
        type = 'browser';
    }
    return type;
};
function watchSDKJSStatus(cb) {
    if (typeof window.XINCHEAPP == 'undefined' && window.loadSDKJSStatus) {
        setTimeout(function () {
            watchSDKJSStatus(cb);
        }, 500);
    }
    else {
        cb();
    }
}
/** 根据环境引入不同的sdk js文件 */
export var loadAPPSDK = function () {
    var apptype = getAppType();
    return new Promise(function (resolve, reject) {
        if (apptype == 'browser') {
            // 浏览器
            reject();
        }
        if (apptype == '58app' && typeof WBAPP != 'undefined') {
            window.XINCHEAPP = WBAPP;
            resolve();
        }
        else if (apptype == '58town' && typeof WBUTOWN != 'undefined') {
            window.XINCHEAPP = WBUTOWN;
            resolve();
        }
        else if (typeof window.XINCHEAPP == 'undefined') {
            // 装载sdk js
            if (window.loadSDKJSStatus) {
                // 判断sdk是否在装在过程中
                watchSDKJSStatus(function () {
                    return resolve();
                });
            }
            else {
                window.loadSDKJSStatus = true;
                loadScript({ url: APPSDK_JS[apptype] })
                    .then(function () {
                    // 装载完成
                    window.loadSDKJSStatus = false;
                    window.XINCHEAPP = apptype == '58town' ? WBUTOWN : WBAPP;
                    resolve();
                })
                    .catch(function () {
                    window.loadSDKJSStatus = false;
                    reject();
                });
            }
        }
        else {
            resolve();
        }
    });
};
/** 判断是否是整合版本后 **/
export var judgeFuseVersion = function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadAPPSDK()
                        .then(function () {
                        var curVersion$ = window.XINCHEAPP.util.getVersion(); //  获取当前版本
                        return (window.XINCHEAPP.util.compareVersion(curVersion$, FUSE_VERSION_STRING) >= 0);
                    })
                        .catch(function () {
                        return false;
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/** 获取用户信息 */
export var getUserInfo = function (key) {
    if (key === void 0) { key = ''; }
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            try {
                window.XINCHEAPP.action.getUserInfo(key, function (str) {
                    var returnValue = !key ? JSON.parse(str) : str;
                    resolve(returnValue);
                });
            }
            catch (error) {
                reject();
            }
        })
            .catch(function () {
            reject();
        });
    });
};
/**
 * 下载58车app
 */
export var download58cheApp = function () {
    // 下载58车app
    var ua = navigator.userAgent;
    var isIos, isAndroid;
    var Android = ua.indexOf('Android') > -1 ||
        ua.indexOf('Adr') > -1 ||
        ua.indexOf('Linux'), // android终端
    Ipad = ua.match(/(iPad).*OS\s([\d_]+)/), // ios终端
    Itouch = !Ipad && ua.match(/(iPod\s?[Ttouch]{5})[a-zA-Z\s;]*([\d_]+)/), Iphone = !Ipad && !Itouch && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    isIos = !!(Iphone || Itouch || Ipad);
    isAndroid = Android > -1;
    var url = isAndroid
        ? '//icon.xgo-img.com.cn/cheandroid/18122114/58Che_android_Newest.apk'
        : isIos
            ? '//itunes.apple.com/cn/app/58%E8%BD%A6/id1108830743'
            : '';
    return url;
};
export var open58App = function (_a) {
    var _b = _a === void 0 ? {} : _a, 
    // 强制以58APP打开
    _c = _b.type, 
    // 强制以58APP打开
    type = _c === void 0 ? 'protocol' : _c, _d = _b.title, title = _d === void 0 ? document.title : _d, _e = _b.url, url = _e === void 0 ? window.location.href : _e;
    var targetUrl;
    if (getAppType() != '58app') {
        return false;
    }
    if (type == 'protocol') {
        // 调起制定协议
        var data = encodeURIComponent(JSON.stringify({ url: url, title: title, pagetype: 'common' }));
        var a = encodeURIComponent('wbmain://jump/core/common?params=' + data);
        targetUrl =
            'https://down.58.com/zt/callappback.html?type=protocol&jumper=' + a;
    }
    else {
        // 调起指定H5页面
        url = encodeURIComponent(url);
        title = encodeURIComponent(title);
        targetUrl =
            'https://down.58.com/zt/callappback.html?url=' + url + '&title=' + title;
    }
    window.location.href = targetUrl;
};
export var setReturnUrl = function (url) {
    /** 没有来源页时，返回按钮强制跳到url */
    if (typeof url == 'undefined' || document.referrer) {
        return false;
    }
    loadAPPSDK()
        .then(function () {
        window.XINCHEAPP.action.deviceEvent('goback', function () {
            window.location.replace(url);
        });
    })
        .catch(function () {
        console.log('error');
    });
};
export var resetReturnFun = function (callback) {
    /** 重置58app返回按钮功能*/
    loadAPPSDK()
        .then(function () {
        window.XINCHEAPP.action.deviceEvent('goback', function () {
            callback();
        });
    })
        .catch(function () {
        console.log('error');
    });
};
/**
 * app内链接跳转
 * @param {string} url 跳转链接 可以是 协议wbmain：//   h5链接   相对路径
 * @param {boolean} preventDefault 是否屏蔽默认行为 默认值是true
 */
var regexp_58_index = /\/\/appsm(()|(-box)|(-test)).58che.com\/58\/index.html/g; // 正则匹配app内嵌页面
var settings = {
    contain_status_bar: false,
    status_bar_mode: '',
    status_bar_color: '',
    hide_title_panel: true,
};
var addFromHost = ['58che.com', '58.com']; // 追加from参数的域名
/**
 * url有四种场景：
 * 1、58che/58域名
 * 2、相对路径
 * 3、58协议地址，形如 wbmain://
 * 4、除已上三种情况外的链接地址，例如第三方秒针监控地址 形如： https://e.cn.miaozhen.com/r/k=2304685&p=8BRaw&dx=__IPDX__&rt=2&pro=s&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&ro=sm&mo=__OS__&m0=__OPENUDID__&m0a=__DUID__&m1=__ANDROIDID1__&m1a=__ANDROIDID__&m2=__IMEI__&m4=__AAID__&m5=__IDFA__&m6=__MAC1__&m6a=__MAC__&m11=__OAID__&m14=__CAID__&m5a=__IDFV__&mn=__ANAME__&m5b=__IDFA1__&m11a=__OAID1__&m14a=__CAID1__&vo=377abf30a&vr=2&o=https%3A%2F%2Ftopic-m.58che.com%2Ftopic%2F4632topic.html%3Fkey%3Dbad8dc2ff61544749b1c8ab8618a29da
 *
 *
 * 针对上面四种场景，有不同的环境判断执行相应的跳转方式
 * 追加from的场景有 1  2
 *  -- 保持原有跳转方式不采用native新页面打开的场景有  4
 * 2023/08/01修改记录
 * 第三方链接放开继续使用wbaction方式进行跳转，之前由于使用action会拼接无用的参数导致页面获取参数失败，
 */
export var goto = function (url, preventDefault, action) {
    if (preventDefault === void 0) { preventDefault = true; }
    if (action === void 0) { action = {
        isfinish: false,
        settings: {
            contain_status_bar: false,
            status_bar_mode: '',
            status_bar_color: '',
            hide_title_panel: false,
        },
    }; }
    if (Object.prototype.toString.call(preventDefault) == '[object Object]') {
        action = preventDefault;
        preventDefault = true;
    }
    var curPageIsFinish = typeof action.isfinish == 'undefined' || !action.isfinish
        ? false
        : action.isfinish;
    url = url.trim();
    var isAddFromHost = url.indexOf('//') == -1, // 该状态位控制是否将from值追加到url后面，只针对58che/58域名以及相对路径的url追加from
    reg = /^(https?:)?\/\/(.*?)(:\d+)?\//; // 正则匹配domain格式
    // isATarget = false; // 该状态位控制是否采用原有默认跳转，只针对非58che/58域名 且不是相对路径和 wbmain协议的url采用原有默认跳转方式，解决秒针监控链接在同城中以新页面打开，安卓环境或自动携带参数问题
    if (reg.test(url)) {
        // 判断是否符合domain格式
        // 获取url domain部分
        var urlDomain_1 = url.match(reg)[0];
        if (urlDomain_1) {
            // 排查url domain 是否是58che/58域名
            isAddFromHost =
                addFromHost.filter(function (item) {
                    return urlDomain_1.indexOf(item) != -1;
                }).length != 0;
        }
    }
    // isATarget = !isAddFromHost && url.indexOf("wbmain://") == -1;
    // console.log(url, `${isAddFromHost ? '' : '不'}追加from值`, isATarget ? 'a标签跳转' : '新载体打开')
    // if(!isATarget){
    loadAPPSDK()
        .then(function () {
        if (preventDefault && event) {
            // @ts-ignore
            event.preventDefault();
        }
        if (url.indexOf('wbmain://') != -1) {
            window.XINCHEAPP.invoke('pagetrans', {
                protocol: url,
            });
        }
        else {
            if (url.indexOf('//') == -1) {
                url = '//' + window.location.hostname + url;
            }
            if (isAddFromHost &&
                url.indexOf('from=') == -1 &&
                getUrlParam('from')) {
                var fromStr = getUrlParam('from').indexOf('#') != -1
                    ? getUrlParam('from').substr(0, getUrlParam('from').indexOf('#'))
                    : getUrlParam('from');
                url = setUrlParam({ url: url, params: { from: fromStr } });
            }
            if (regexp_58_index.test(url)) {
                regexp_58_index.lastIndex = 0;
                // 11.1.0版本 内嵌app页面选新车走wbmain协议
                judge58Version('11.1.0')
                    .then(function () {
                    window.XINCHEAPP.action.pagetrans('core', {
                        pagetype: 'common',
                        url: url,
                        settings: settings,
                        isfinish: curPageIsFinish,
                    });
                })
                    .catch(function () {
                    window.XINCHEAPP.action.pagetrans('core', {
                        pagetype: 'common',
                        url: url,
                        settings: action.settings,
                        isfinish: curPageIsFinish,
                    });
                });
            }
            else {
                var model = 'common';
                if (url.indexOf('cleanWeb://') > -1) {
                    // 需要走纯净协议的方式
                    model = 'cleanWeb';
                    url = url.replace('cleanWeb://', '');
                    // alert(url + 110)
                }
                window.XINCHEAPP.action.pagetrans('core', {
                    pagetype: model,
                    url: url,
                    settings: action.settings,
                    isfinish: curPageIsFinish,
                });
            }
        }
    })
        .catch(function () {
        console.log('error');
    });
    // }
};
/**
 * 判断58app版本是否高于versionNum
 * @param {string|object} versionNum   如果是string类型，则代表58app对比的版本号形如 9.10.0
 *                                     如果是object类型，key值命名规则为version_${getAppType()} 对应的是相应的app版本号
 * 例如 58app 对比值是9.10.0  58town对比版本值是 10.10.0  则 versionNum 为{version_58app:'9.10.0',version_58town:'10.10.0'}
 */
export var judge58Version = function (versionNum) {
    return new Promise(function (resolve, reject) {
        if (typeof versionNum == 'undefined' ||
            (typeof versionNum == 'string' && !versionNum.trim())) {
            reject();
        }
        loadAPPSDK()
            .then(function () {
            var apptype = getAppType();
            var curVersion = window.XINCHEAPP.util.getVersion(); // 假定为: 7.4.1
            var compareVersion;
            if (apptype != '58app' && typeof versionNum == 'string') {
                // versionNum 为字符串时，表示versionNum 是58app的版本号，顾直接执行reject
                if (apptype == '58town') {
                    // 同镇整合暂定12.0.0版本  测试包版本号为11.9.0
                    compareVersion = versionNum;
                }
                else {
                    reject('缺少比较版本参数');
                }
            }
            else if (apptype == '58app' && typeof versionNum == 'string') {
                compareVersion = versionNum;
            }
            else if (typeof versionNum == 'object' &&
                versionNum["version_" + apptype]) {
                compareVersion = versionNum["version_" + apptype];
            }
            else {
                reject('缺少比较版本参数');
            }
            try {
                var status_1 = window.XINCHEAPP.util.compareVersion(curVersion, compareVersion) >=
                    0;
                if (status_1) {
                    // 当前版本高于versionNum
                    resolve('gt');
                }
                else {
                    // 当前版本低于versionNum
                    reject('lt');
                }
            }
            catch (err) {
                reject('获取版本号报错');
            }
        })
            .catch(function () {
            reject('非app内');
        });
    });
};
export var isNativePage = typeof window != 'undefined' ? getUrlParam('nativeEmbed') : ''; // 是不是native内嵌页
export var isDark = typeof window != 'undefined' ? getUrlParam('dark') : ''; // 通过url地址参数判断是不是暗黑模式
/**
 * 暗黑模式下为body添加dark 类名
 * 判断暗黑模式的依据
 * 1、通过url里面参数 dark=1 是暗黑模式
 * 2、协议wbmain打开此页面时，且协议配置中userInterfaceStyle=true时，手机及58app均开始深色模式时
 */
export var addDarkModel = function (cn) {
    if (cn === void 0) { cn = 'dark'; }
    if (getAppType() == '58town') {
        return false;
    }
    var x = window.matchMedia('(prefers-color-scheme: dark)');
    if (isDark) {
        // 暗黑模式
        document.getElementsByTagName('body')[0].classList.add(cn);
        return;
    }
    loadAPPSDK()
        .then(function () {
        window.XINCHEAPP.invoke('toggle_userinterfacestyle', {
            userInterfaceStyle: '0',
        });
        _darkModelFun();
        x.addListener(_darkModelFun); // 状态改变时添加监听器 模式修改的时候触发
    })
        .catch(function () {
        console.log('非app内');
    });
    function _darkModelFun() {
        if (x.matches) {
            // 媒体查询
            // 暗黑模式
            document.getElementsByTagName('body')[0].classList.add(cn);
        }
        else {
            // 明亮模式
            document.getElementsByTagName('body')[0].classList.remove(cn);
        }
    }
};
/**
 * 获取58app设备信息
 */
export var getImei = function () {
    return new Promise(function (resolve, reject) {
        getUserInfo()
            .then(function (obj) {
            var imei = obj.platform == 'android' ? obj.imei : obj.openudid, xxwxtoken = typeof obj.xxwxtoken == 'undefined' ? '' : obj.xxwxtoken, xxwxtokenp = typeof obj.xxwxtokenp == 'undefined' ? '' : obj.xxwxtokenp, openudid = typeof obj.openudid == 'undefined' ? '' : obj.openudid, os = typeof obj.os == 'undefined' ? '' : obj.os, version = typeof obj.version == 'undefined' ? '' : obj.version, 
            // 58clientId
            clientId = typeof obj['58clientid'] == 'undefined' ? '' : obj['58clientid'];
            if (typeof imei == 'undefined') {
                imei = '';
            }
            resolve({
                imei: imei,
                xxwxtoken: xxwxtoken,
                xxwxtokenp: xxwxtokenp,
                openudid: openudid,
                os: os,
                version: version,
                clientId: clientId,
            });
        })
            .catch(function () {
            reject('非58app环境');
        });
    });
};
/**
 * 隐藏/显示顶部标题栏
 * cmd	String	✔️	事件名 'show' / 'hide'
 * animation	String	✘	动画名 默认值为 'easeIn'
 * duration	String	✘	动画时间 默认值：'300'ms
 * callback  可选
 */
export var toggleTitlePanel = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.cmd, cmd = _c === void 0 ? '' : _c, _d = _b.animation, animation = _d === void 0 ? 'easeIn' : _d, _e = _b.duration, duration = _e === void 0 ? '300' : _e, _f = _b.contain_status_bar, contain_status_bar = _f === void 0 ? false : _f, _g = _b.keep_through, keep_through = _g === void 0 ? false : _g, 
    // eslint-disable-next-line no-empty-function
    _h = _b.callback, 
    // eslint-disable-next-line no-empty-function
    callback = _h === void 0 ? function () { } : _h;
    return new Promise(function (resolve, reject) {
        if (cmd == '') {
            reject('cmd事件名为必填项');
        }
        else {
            loadAPPSDK()
                .then(function () {
                window.XINCHEAPP.invoke('toggle_title_panel', {
                    cmd: cmd,
                    animation: animation,
                    duration: duration,
                    contain_status_bar: contain_status_bar,
                    keep_through: keep_through,
                }, function () {
                    callback();
                    resolve(true);
                });
            })
                .catch(function () {
                reject('非app内调用');
            });
        }
    });
};
/* 返回到上级页面
 *  isBacktoroot	bool	default false
 */
export var goback = function (isBacktoroot) {
    if (isBacktoroot === void 0) { isBacktoroot = false; }
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            window.XINCHEAPP.action.goback(isBacktoroot);
            resolve(true);
        })
            .catch(function () {
            reject('非app内调用');
        });
    });
};
/* 判断用户是否登录
 * @param callback 回调函数  选填返回 promise
 * return promise
 */
// eslint-disable-next-line no-empty-function
var callback_is_login = function (state) { };
export var isLogin = function (callback) {
    if (callback === void 0) { callback = callback_is_login; }
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            window.XINCHEAPP.action.isLogin(function (state) {
                callback(state);
                resolve(state);
            });
        })
            .catch(function () {
            reject('非app内调用！');
        });
    });
};
/* 唤起本地版登录页
 *  state   0：成功 1：失败
 *  callback 非必选
 *  return promise
 */
// eslint-disable-next-line no-empty-function
var callback_login = function (state) { };
export var login = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.callback, callback = _c === void 0 ? callback_login : _c, _d = _b.source, source = _d === void 0 ? '' : _d;
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            window.XINCHEAPP.action.login(function (state) {
                // console.log('登陆现在状态：',state)
                callback(state);
                resolve(state);
            }, source);
        })
            .catch(function () {
            reject('非app内调用！');
        });
    });
};
/* 获取经纬度及地图名称
   由于安卓自2019年3月之后获取的是首页的定位，ios获取的是当前的定位，建议使用getUserInfo方法获取header里面的定位信息
    callback 为非必填参数
    return promise
*/
// eslint-disable-next-line no-empty-function
var callback_get_position = function (param) { };
export var getPosition = function (callback) {
    if (callback === void 0) { callback = callback_get_position; }
    var apptype = getAppType();
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            // if (apptype == "58town") {
            //   getUserInfo()
            //     .then((val: any) => {
            //       callback({ lon: val.bdLon, lat: val.bdLat, source: "baidu" });
            //       resolve({ lon: val.bdLon, lat: val.bdLat, source: "baidu" });
            //     })
            //     .catch(() => {
            //       reject("getUserInfo调用失败！");
            //     });
            // } else {
            window.XINCHEAPP.action.getPosition(function (lon, lat, source) {
                callback({ lon: lon, lat: lat, source: source });
                resolve({ lon: lon, lat: lat, source: source });
            });
            // }
        })
            .catch(function () {
            reject('非app内调用！');
        });
    });
};
export var getStatusBar = function () {
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            window.XINCHEAPP.invoke('get_status_bar', function (resp) {
                var barInfo = JSON.parse(resp);
                if (barInfo.height === '0') {
                    barInfo.height = '20';
                }
                resolve(barInfo);
            });
        })
            .catch(function () {
            // console.log('getStatusBar catch');
            reject();
        });
    });
};
/** 设置状态栏 字体颜色和背景色 */
// color: argb的颜色值
export var setStatusBar = function (barInfo) {
    loadAPPSDK()
        .then(function () {
        var params = {};
        params.mode = barInfo.mode || 'light';
        barInfo.color && (params.color = barInfo.color);
        window.XINCHEAPP.invoke('set_status_bar', params);
    })
        .catch(function () {
        // console.log('setStatusBar catch');
    });
};
// export const newcarCommonBox = (show = 0) => {
//   loadAPPSDK()
//     .then(() => {
//       window.XINCHEAPP.invoke('newcar_commonbox',{
//         show: show
//       })
//     })
//     .catch(() => {
//       console.log('newcar_common error');
//     })
// }
// export const newcarCommonReply = (actionCommentReply: string|number) => {
//   loadAPPSDK()
//     .then(() => {
//       window.XINCHEAPP.invoke('newcar_commonReply',{
//         actionCommentReply
//       })
//     })
//     .catch(() => {
//       console.log('newcar_common error');
//     })
// }
/*
新车筛选 map映射
*/
var itemTypes = {
    d: 'displacement',
    c: 'nation',
    g: 'gearbox',
    m: 'mileage',
    f: 'fuel',
    l: 'level',
    p: 'price',
    b: 'brand',
    u: 'use', // 用途
};
// url 车系筛选地址  from_code
export function jumpNativeFilterPage(url, from_code) {
    // 匹配特定数据
    var regexp = /\/([0-9a-z]|[a-z]|,|-|_|)+\.html/;
    var urlArray = regexp.exec(url);
    var filter = [];
    // 没有匹配到数据
    if (!urlArray) {
        console.warn("function->jumpNativeFilterPage:\u672A\u5339\u914D\u5230\u53C2\u6570\uFF01");
    }
    else {
        var paramsString = urlArray[0].substr(1).split('.')[0];
        var paramsArray = paramsString.split('_');
        paramsArray.map(function (item, index) {
            var itemType = item.substr(0, 1);
            var values = item.substr(1).split(',');
            values.map(function (value, index) {
                filter.push({ itemtype: itemTypes[itemType], value: value });
            });
        });
    }
    var action = {
        content: {
            pagetype: 'newcarFilterList',
            param: {
                filter: filter,
                from_code: from_code || getUrlParam('from') || getCookie('from_code'),
            },
        },
        tradeline: 'newcar',
        action: 'pagetrans',
    };
    // 跳转native逻辑
    loadAPPSDK()
        .then(function () {
        judge58Version('10.19.0')
            .then(function () {
            window.XINCHEAPP.invoke('pagetrans', action);
        })
            .catch(function (e) {
            window.XINCHEAPP.action.pagetrans('core', {
                pagetype: 'common',
                url: url,
            });
        });
    })
        .catch(function (e) {
        window.location.href = url;
    });
}
export function encryptText(text) {
    return new Promise(function (resolve, reject) {
        loadAPPSDK()
            .then(function () {
            judge58Version(isAndroid() ? '10.23.2' : '10.23.5')
                .then(function () {
                window.XINCHEAPP.invoke('xxwx', {
                    value: text,
                }, function (resp) {
                    var result = JSON.parse(resp);
                    if (result.code === 0) {
                        resolve(result);
                    }
                    else if (result.code === 1) {
                        reject('获取加密信息失败，请重试');
                    }
                    else if (result.code === 2) {
                        // 不存在这种情况，依赖于sdk版本，需要cachevers>1080
                    }
                });
            })
                .catch(function () {
                resolve(text);
            });
        })
            .catch(function () {
            reject('当前不是58app');
        });
    });
}
export function isAndroid() {
    var ua = navigator.userAgent;
    var isAndroid;
    var Android = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('Linux'); // android终端
    isAndroid = Android > -1;
    return isAndroid;
}
export function isIos() {
    var ua = navigator.userAgent;
    var isIos;
    var Ipad = ua.match(/(iPad).*OS\s([\d_]+)/), // ios终端
    Itouch = !Ipad && ua.match(/(iPod\s?[Ttouch]{5})[a-zA-Z\s;]*([\d_]+)/), Iphone = !Ipad && !Itouch && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    isIos = !!(Iphone || Itouch || Ipad);
    return isIos;
}
